var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid drip-campaign-edit-wrapper" },
    [
      _c(
        "div",
        { staticClass: "form-page px-md-5" },
        [
          _vm.loading.campaign && !_vm.loading.saving
            ? _c("drip-campaign-edit-header-loader")
            : _c(
                "div",
                [
                  _c("drip-campaign-edit-header", {
                    attrs: {
                      name: _vm.currentCampaign.name,
                      clients: _vm.currentCampaign.clients,
                      "campaign-id": _vm.campaignId,
                      active: _vm.currentCampaign.active,
                      "is-valid": _vm.isValid,
                      "loading-saving": _vm.loading.saving,
                      "email-verified":
                        _vm.currentCampaign.emailVerified || false,
                      "created-by": _vm.currentCampaign.createdBy,
                    },
                    on: { "save-changes": _vm.handleSaveChanges },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          _vm.loading.campaign
            ? _c("drip-campaign-edit-loader")
            : _c(
                "div",
                [
                  _c("drip-campaign-edit-name", {
                    attrs: { name: _vm.currentCampaign.name, $v: _vm.$v },
                  }),
                  _vm._v(" "),
                  _c("drip-campaign-edit-contact", {
                    attrs: {
                      "current-campaign": _vm.currentCampaign,
                      $v: _vm.$v,
                    },
                  }),
                  _vm._v(" "),
                  _c("drip-campaign-edit-criteria", {
                    attrs: {
                      automation: _vm.automation,
                      triggers: _vm.currentCampaign.triggers,
                    },
                  }),
                  _vm._v(" "),
                  _c("drip-campaign-edit-criteria", {
                    attrs: {
                      "exit-criteria": "",
                      automation: _vm.automation,
                      triggers: _vm.currentCampaign.triggers,
                    },
                  }),
                  _vm._v(" "),
                  _c("drip-campaign-edit-stages", {
                    attrs: {
                      stages: _vm.currentCampaign.stages,
                      "campaign-id": _vm.campaignId,
                      $v: _vm.$v,
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }